'use client';

// Defer children until after mount when SSR vs client can differ (timezone, locale,
// storage, etc.) — avoids hydration mismatches including React #418.
import { ReactNode, useEffect, useState } from 'react';

interface ClientOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return <>{mounted ? children : fallback}</>;
}

export default ClientOnly;
